export function createSheetTabParam(tabs, defaultTab) {
    if (!tabs.includes(defaultTab)) {
        throw new Error(`Scheda di default sconosciuta: ${defaultTab}`);
    }
    const isTab = (value) => tabs.includes(value);
    return {
        tabs,
        defaultTab,
        isTab,
        resolve: (value) => (isTab(value) ? value : defaultTab),
        toParam: (tab) => (tab === defaultTab ? undefined : tab),
    };
}
//# sourceMappingURL=sheet-tab-param.js.map